module.exports = __webpack_public_path__ + "img/converter.b027d042.png";